<script setup>
import { onMounted, ref } from 'vue'
import { init } from 'https://cdn.jsdelivr.net/npm/shareon@2/dist/shareon.es.js'


onMounted(() => {
  init()
})

const toggleShareBar = () => {
  const shareon = document.querySelector('.shareon')
  shareon.classList.toggle('hidden')
}
const gmailUrl = ref(`https://mail.google.com/mail/?view=cm&fs=1&to=&su=${encodeURIComponent(document.title)}&body=${encodeURIComponent(window.location.href)}`)
</script>

<template>
  <link
    href="https://cdn.jsdelivr.net/npm/shareon@2/dist/shareon.min.css"
    rel="stylesheet"
  />
  <div class="relative">
    <div class="right-0 z-10 absolute bg-white rounded wrapper flex items-start flex-col">
      <Icon
        icon="heroicons-outline:share"
        class="hover:shadow border rounded-lg p-2 h-10 w-10 mb-2 shrink-0"
        @click="toggleShareBar"
      />
      <div class="shareon flex flex-col hidden" @click="toggleShareBar">
        <a class="facebook h-4"></a>
        <a class="linkedin"></a>
        <a class="twitter"></a>
        <a class="whatsapp"></a>
        <a
          class="bg-center shadow-lg bg-no-repeat bg-[url('assets/icons/gmail.svg')]" :href="gmailUrl" target="_blank"
          style="background-color:white;"
        ></a>
        <a class="copy-url"></a>
        <a class="email"></a>
      </div>
    </div>
  </div>
</template>